<template>
  <layout>
  <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
  <div class="el-form-content" slot="content">
    <el-form size="mini" label-width="80px">
      <el-row>
        <el-col :span="10">
          <el-form-item label="1.서비스 접수번호">
            <el-input readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="상담유형">
            <el-input v-model="form.callClass" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-row>
            <el-form-item label="상담분류">
              <el-col :span="8">
                <el-input v-model="form.callCatId1" readonly></el-input>
              </el-col>
              <el-col :span="8">
                <el-input v-model="form.callCatId2" readonly></el-input>
              </el-col>
              <el-col :span="8">
                <el-input v-model="form.callCatId3" readonly></el-input>
              </el-col>
            </el-form-item>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="제조사">
            <el-input v-model="form.makerNm" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="제품군">
            <el-input v-model="form.modelGroupNm" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="대표모델">
            <el-input v-model="form.standardModelNm" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="모델">
            <el-input v-model="form.modelNm" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="문의내역">
            <el-input type="textarea" v-model="form.question" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="답변내역">
            <el-input type="textarea" v-model="form.answer" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="기타메모">
            <el-input type="textarea" v-model="form.memo" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="고객명">
            <el-input v-model="form.boundCustNm" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="연락처">
            <el-input v-model="form.callTelNo" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="처리결과">
            <el-radio-group v-model="form.callTypeNm" disabled>
              <el-radio
                v-for="item in data.callTypeRadio"
                :key="item.key"
                :label="item.value"
                :value="item.key">
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="상담원">
            <el-input v-model="form.chargeNm" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

  </div>
</layout>
</template>

<script>
/**
* * components
*/
import Layout from '@/components/Slot/ModalSlot.vue';
import {AgGridVue} from 'ag-grid-vue';

import mixin from './index';

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

export default {
  mixins: [mixin],
  props: {
      printForm: {
          Type: Array
          , required: false
      }
  },
  components: {Layout, AgGridVue},
  data() {
      return {
          title: '제품 불량 판정서(고객용) ==> TODO: 공통 게시판 양식 샘플로 교체필요',
          form: {
            modelGroupNm: '',
            callClass: '', /** 상담유형 */
            callCatId1: '', /** 상담분류(대) */
            callCatId2: '', /** 상담분류(중) */
            callCatId3: '' /** 상담분류(소) */
          },
          search: '',
          deptCd: '1',
          mobileGb: 'h',
          callClassOpt: [], /** 상담유형리스트 */
          callClassIdOpt: [], /** 상담유형리스트 Id */
          callCatIdOpt1: [], /** 상담분류(대) */
          callCatIdIdOpt1: [], /** 상담분류(대) Id */
          callCatIdOpt2: [], /** 상담분류(중) */
          callCatIdIdOpt2: [], /** 상담분류(중) Id */
          callCatIdOpt3: [], /** 상담분류(소) */
          callCatIdIdOpt3: [] /** 상담분류(소) Id */
      }
  },
  created() {
    this.form = this.data;
    this.$bus.$on('input', (val) => {
        console.log('-> input bus on ', val);
    });
  },
  mounted() {
      this.selectNormalConsultDetail()
      //pop slots modal move
      $(".animation-content").addClass('pop_min2');
      $(".animation-content").draggable({'cancel':'.modal-card-body'});
      //ModalSlot open z-index change
      $('.lnb').css('z-index', '4');
  },
  destroyed() {
      //ModalSlot open z-index change
      $('.lnb').css('z-index', '7');
  },
  methods: {

      closeModal() {
          this.$parent.close();
      },
      onGridReady(){

      },
      selectNormalConsultDetail(){

      }

  }

}
</script>

<style lang="scss" scoped>

.el-form-content {
  border: 1px solid #d7d7d7 !important;
  padding: 10px 10px 10px 0;
  border-radius: 5px;
  margin-left: 0px;
    .el-form-item {
        margin-left: -5px;
        // margin-right: 0px;
    }
}
</style>